import { render, staticRenderFns } from "./ComboModal.vue?vue&type=template&id=bb21a7e8&"
import script from "./ComboModal.vue?vue&type=script&lang=js&"
export * from "./ComboModal.vue?vue&type=script&lang=js&"
import style0 from "./ComboModal.vue?vue&type=style&index=0&id=bb21a7e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports